
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.RoutePathDeviation = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'RoutePathDeviationEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'maximumDeviationContainer'
            }
          },
          {
            attributes: {
              class: 'control-group',
              id: 'minimumTimeContainer'
            }
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const maximumDeviation = new Monet.UI.Fields.Render({
      name: 'maximumDeviation',
      label: Greenmile.Utils.getResourceWithUnitMetric('event.routepath.maximumdeviation'),
      mandatory: false,
      type: 'MILES_OR_METERS',
    }).render();

    const minimumTime = new Monet.UI.Fields.Render({
      name: 'minimumTime',
      label: 'event.routePathDeviation.minimumTime',
      mandatory: false,
      type: 'INTEGER',
    }).render();

    Greenmile.Checks.EventCheck.RoutePathDeviation.fields = { maximumDeviation, minimumTime };

    //Append fields to DOM  
    const maximumDeviationContainer = document.querySelector('#RoutePathDeviationEvent #maximumDeviationContainer');
    maximumDeviationContainer.appendChild(maximumDeviation.rootEl);

    const minimumTimeContainer = document.querySelector('#RoutePathDeviationEvent #minimumTimeContainer');
    minimumTimeContainer.appendChild(minimumTime.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.RoutePathDeviation.renderFields();
    const fields = Greenmile.Checks.EventCheck.RoutePathDeviation.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.maximumDeviation.setValue(jsonParam.maximumRouteDeviationMeters);
      fields.minimumTime.setValue(jsonParam.minimumTimeDeviationMin);
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.RoutePathDeviation.fields;
    return JSON.stringify({
      maximumRouteDeviationMeters: fields.maximumDeviation.getValue().toString(),
      minimumTimeDeviationMin: fields.minimumTime.getValue().toString()
    });
  }

};
